import { createTheme } from '@mui/material/styles';

export const denthubTheme = createTheme({
    typography: {
        fontFamily: 'Inter, sans-serif',
        h1: {
            fontSize: '1.9em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h2: {
            fontSize: '1.4em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h3: {
            fontSize: '1.2em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
            color: '#444',
        },
        h4: {
            fontSize: '1em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
            color: '#444',
        },
        h5: {
            fontSize: '0.9em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h6: {
            fontSize: '1.1em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        subtitle2: {
            fontSize: '0.9rem',
            fontWeight: 600,
        },
        button: {
            fontWeight: 600,
        },
    },
    spacing: 10,
    palette: {
        background: {
            default: '#fdfbfd',
        },
        primary: {
            main: '#1b6eb7',
            contrastText: '#fff',
        },
        secondary: {
            main: '#64AFA4',
        },
        brand: {
            main: '#F9C7B3',
        },
        calm: {
            dark: '#376C60',
            main: '#478A7E',
            light: '#DBECEA',
        },
        focus: {
            dark: '#E84F30',
            main: '#EC6F57',
            light: '#F4AD9F',
        },
        extra: {
            dark: '#20476F',
            main: '#3876B7',
            light: '#6B9CD1',
        },
        ai: {
            dark: '#441c5e',
            main: '#ca67f5',
            light: '#efe1f5',
        },
        success: {
            main: '#268320',
        },
        error: {
            main: '#D62400',
        },
        divider: '#bbb',
    },
    shape: {
        borderRadius: 2,
    },
    components: {
        MuiAppBar: {
            defaultProps: {
                style: {
                    backgroundColor: '#000',
                    color: '#fff',
                    boxShadow: 'none',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontSize: '0.9rem',
                    fontWeight: 600,
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    borderBottom: '3px solid',
                    borderBottomColor: '#F9C7B3',
                    '& .MuiTableCell-head': {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: '#F3F7F7',
                    },
                    '&.MuiTableRow-hover:hover': {
                        backgroundColor: '#F9FBFB',
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 5,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f1f1f1',
                    borderBottom: '1px solid #ddd',
                    marginBottom: 20,
                },
            },
        },
        MuiDialogActions: {
            defaultProps: {
                style: {
                    borderTop: '1px solid #ddd',
                    padding: 20,
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                color: 'secondary',
                style: {
                    backgroundColor: '#fff',
                },
                size: 'small',
            },
        },
        MuiSelect: {
            defaultProps: {
                color: 'secondary',
                style: {
                    backgroundColor: '#fff',
                },
                size: 'small',
            },
        },
        MuiFormControl: {
            defaultProps: {
                color: 'secondary',
                size: 'small',
            },
        },
        MuiButton: {
            defaultProps: {
                size: 'medium',
            },
            styleOverrides: {
                root: {
                    borderRadius: '3px',
                    boxShadow: 'none',
                    textTransform: 'none', // Prevent uppercase text
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                outlined: {
                    borderColor: '#ddd',
                },
            },
        },
    },
});

declare module '@mui/material/styles' {
    interface Palette {
        brand: Palette['primary'];
        calm: Palette['primary'];
        focus: Palette['primary'];
        extra: Palette['primary'];
        ai: Palette['primary'];
    }
    interface PaletteOptions {
        brand: PaletteOptions['primary'];
        calm: PaletteOptions['primary'];
        focus: PaletteOptions['primary'];
        extra: PaletteOptions['primary'];
        ai: PaletteOptions['primary'];
    }
}
